'use client';

import { createPortal } from 'react-dom';
import { Modal } from '@/components/modal';
import { useNotificationModal } from '@/lib/context/NotificationModalContext';
import { MobileRegisterNotification } from '@/app/register/components/MobileRegisterNotification';

export const NotificationModal = () => {
  const { isOpen, closeModal } = useNotificationModal();

  if (!isOpen || typeof window === 'undefined') return null;

  return createPortal(
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      className="fixed w-[95%] max-w-[488px] py-4 bg-gray-800 z-[2] rounded-2xl"
    >
      {(handleClose: () => void) => <MobileRegisterNotification handleClose={handleClose} />}
    </Modal>,
    document.body
  );
};
